export default {"src":"/_next/static/media/NeuroSurgery.b1c80a02.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};